import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import TaxCalculator from "../tax-calculator/tax-calculator";
import { observer } from "mobx-react";
import PolicyFeeStore from "../../../../stores/policy-fee-store";
import { CHARGE_OPTIONS } from "../../../../constants";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import Hr from "../../../../../../components/hr/hr";
import AmountSettings from "../amount-settings/amount-settings";
import { PROFILE_CAPABILITIES } from "../../../../../../models/ProfileCapabilities";
import ResolveCapability from "../../../../../../components/resolve-capability/resolve-capability";
import currentPortalStore from "../../../../../../stores/current-portal-store";
import { FUNC } from "../../../../../../stores/platform-service-store";

interface IProps {
    fee: PolicyFeeStore | undefined;
    validationGroup: IValidationGroup;
}

const RestockingFee: React.FC<IProps> = observer(({ fee, validationGroup }) => {
    if (!fee) {
        return null;
    }

	const canChargeTaxForFee = currentPortalStore.platform?.isFunctionalitySupported(FUNC.FUNC_CHARGE_TAXES_FOR_FEES);

	return (
        <div className="policy-fee">
            <FormFieldLine
                label='Restocking Fee (per item)'
                note='Set a restocking fee to charge and determine how it will be calculated.'
            >
                <SelectDropdown
                    value={CHARGE_OPTIONS.find(o => Boolean(o.value) === fee.isCharged)}
                    options={CHARGE_OPTIONS}
                    onChange={(v) => { fee.setIsCharged(Boolean(v?.value)); }}
                    validationGroup={validationGroup}
                    required
                    isSearchable={false}
                />

            </FormFieldLine>
            {fee.isCharged && (
                <>
                    <FormFieldLine label=''>
                        <AmountSettings fee={fee} validationGroup={validationGroup} />
                    </FormFieldLine>
	                <ResolveCapability capability={PROFILE_CAPABILITIES.FEE_TAXES_CALCULATION}>
		                {({ isSupported}) => (isSupported && canChargeTaxForFee) && (
			                <FormFieldLine
				                label='Tax Calculation'
				                labelIndent={1}
			                >
				                <TaxCalculator fee={fee} validationGroup={validationGroup} />
			                </FormFieldLine>
		                )}
	                </ResolveCapability>
                </>
            )}
            <Hr />
        </div>
    );
});

export default RestockingFee;
